import { render } from "./TransactionCards.vue?vue&type=template&id=fdb8c64e&scoped=true"
import script from "./TransactionCards.vue?vue&type=script&lang=js"
export * from "./TransactionCards.vue?vue&type=script&lang=js"

import "./TransactionCards.vue?vue&type=style&index=0&id=fdb8c64e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdb8c64e"]])

export default __exports__